import { Plugin, PluginKey } from "prosemirror-state";
import type { EditorView } from "prosemirror-view";

export const hyperlinkKey = new PluginKey("hyperlinks");

export interface NavigateTarget {
  documentId: string;
  sid?: string;
  viewspec?: string;
}

/**
 * Plugin that handles clicking on NLS links.
 * Calls the onNavigate callback when a link is clicked.
 */
export function hyperlinkPlugin(
  onNavigate: (target: NavigateTarget) => void
): Plugin {
  return new Plugin({
    key: hyperlinkKey,
    props: {
      handleClick(view: EditorView, pos: number, event: MouseEvent) {
        // Check if click target is a link
        const target = event.target as HTMLElement;
        const linkEl = target.closest("a.nls-link") as HTMLElement | null;
        if (!linkEl) return false;

        const documentId = linkEl.getAttribute("data-doc");
        const sid = linkEl.getAttribute("data-sid");
        const viewspec = linkEl.getAttribute("data-viewspec");

        if (documentId) {
          event.preventDefault();
          onNavigate({
            documentId,
            sid: sid || undefined,
            viewspec: viewspec || undefined,
          });
          return true;
        }

        return false;
      },
    },
  });
}
